import React from 'react';
import { ArrowUp } from 'react-feather';

import IconButton from '../buttons/IconButton';

function SortDirectionButton({ onChange, value }) {
    return (
        <IconButton
            styles="border border-gray-300"
            size="small"
            onClick={() => onChange(value === 'ASC' ? 'DESC' : 'ASC')}
        >
            <div className={`transition ${value === 'DESC' ? 'transform rotate-180' : ''}`}>
                <ArrowUp className="w-5 h-5" />
            </div>
        </IconButton>
    );
}

SortDirectionButton.propTypes = {};

export default SortDirectionButton;
